import script from "./RootArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootArticle.vue?vue&type=script&setup=true&lang=ts"

import "./RootArticle.vue?vue&type=style&index=0&id=05288ce2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05288ce2"]])

export default __exports__